"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const shuffle = require('lodash/shuffle');
const sample = require('lodash/sample');
const sponsoredArtworks = require('../data/sponsored/artworks.json');
const sponsoredArtists = require('../data/sponsored/artists.json');
const getRandomizedSponsoredItems = () => {
    const artworks = sponsoredArtworks.map((artwork) => (Object.assign({ type: 'SPONSORED_ARTWORK' }, artwork)));
    const artists = sponsoredArtists.map((artist) => (Object.assign({ type: 'SPONSORED_ARTIST' }, artist)));
    // This picks a list of either artworks or artitsts
    // and then randomizes the values.
    return shuffle(sample([artworks, artists]));
};
module.exports = {
    getRandomizedSponsoredItems,
};
